import React, { useEffect, useState } from "react";
import { normalizeZIP } from "./shipping-info";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  greenLabel: {
    color: "green",
  },

  redLabel: {
    color: "red",
  },

  greenOutline: {
    "&$cssFocused $notchedOutlineGreen": {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },

  redOutline: {
    "&$cssFocused $notchedOutlineRed": {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },

  focused: {},

  notchedOutlineGreen: {
    borderWidth: "1px",
    borderColor: "green !important",
  },
  notchedOutlineRed: {
    borderWidth: "1px",
    borderColor: "red !important",
  },
}));

const checkZipCode = (zipCode) => zipCode && /^\d{2}-\d{3}$/.test(zipCode);

const ZipInput = ({
  zipCode,
  setZipCode,
  isValidListener,
  disabled,
  setDataChanged,
}) => {
  const cls = useStyles();

  const [valid, setValid] = useState(checkZipCode(zipCode));
  const [isPostalCodeValid, setIsPostalCodeValid] = useState(true);
  useEffect(() => {
    let isOk;
    if (zipCode && /^\d{2}-\d{3}$/.test(zipCode)) {
      isOk = true;
    } else {
      isOk = false;
    }

    setValid(isOk);

    isValidListener && isValidListener(isOk);
  }, [zipCode]);

  return (
    <TextField
      label="Kod pocztowy"
      variant="outlined"
      value={zipCode || ""}
      disabled={disabled}
      fullWidth
      onChange={({ target: { value: newZipCode } }) => {
        setDataChanged(true);
        setZipCode(normalizeZIP(newZipCode, zipCode));
        let postalCode = "";
        newZipCode.length > 6
          ? (postalCode = newZipCode.substring(0, 6))
          : (postalCode = newZipCode);
        let isOk;
        if (
          (postalCode && /^\d{2}-\d{3}$/.test(postalCode)) ||
          postalCode === "" ||
          postalCode === undefined
        ) {
          isOk = true;
        } else {
          isOk = false;
        }

        setIsPostalCodeValid(isOk);
      }}
      error={!isPostalCodeValid}
      helperText={!isPostalCodeValid && "Nieprawidłowy format."}
    />
  );
};

export default ZipInput;
